/**
 * 知识库问答Mixin
 */
export default {
    methods: {

        /**
         * 知识库对话提问
         */
        knowledgeAsk (data) {
            if (!this.currentKnowledge) return;
            if (this.ui.typing) return;
            let prompt = data.input;
            let useLLM = this.useLLM;
            let knowledgeId = this.currentKnowledge.knowledgeId;
            this.prompt = '';
            this.addAsk(prompt);

            // 文字提问
            let question = { question: prompt, knowledgeId, topN: this.modelSettings.topN };
            // let msg = {
            //     'ask': JSON.stringify(question),
            //     'useLLM': useLLM,
            //     'type': 'TEXT',
            //     contextLimit: this.modelSettings.contextLimit,
            //     temperature: this.modelSettings.temperature,
            //     maxLength: this.modelSettings.maxLength
            // };
            // this.socket.send(msg);
            let sseMsg = {
                ...question,
                'model': useLLM,
                'stop': ['\r\n\r\nHuman', '\r\nHuman', '\n\nHuman', '\nHuman'], // 流式停止标识
                contextLimit: this.modelSettings.contextLimit,
                temperature: this.modelSettings.temperature,
                maxTokens: this.modelSettings.maxLength,
                isDebug: true
            };
            // 开始等待打字
            this.ui.typing = true;
            this.currentChat.messages.push({ role: 'assistant', content: '', feedback: null, finished: false });
            this.sendSseStream(sseMsg, 'knowledge');
        }
    }
};
